import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {WhiteLabelProfileData} from '../../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {GetAllWhiteLabel} from '../../WhiteLabelSlice/WhiteLabelSlice'
import {fetchAsyncUserDetails} from '../../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  WhiteLabelUserList: [],
}

////////////////////////////////////ASSIGNEE USER LIST////////////////////////////////////////////

export const GetAllUSerOfWhiteLabel: any = createAsyncThunk(
  '/GetAllUSerOfWhiteLabel',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}admin/getAllUserAccount`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    return response.data
  }
)

export const WhiteLabelfreeCreditToUser: any = createAsyncThunk(
  'WhiteLabelfreeCreditToUser',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/addFreeCreditsToUser`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(WhiteLabelProfileData(data?.accountId))
    thunkApi.dispatch(fetchAsyncUserDetails())
    {
      response.data.status == true
        ? toast.success(
            typeof response.data.data == 'string' ? response.data.data : 'Credit Added Successfully'
          )
        : toast.error(response.data.message)
    }
    return response.data
  }
)
// export const UpdateAssigneTo: any = createAsyncThunk(
//   '/UpdateAssigneTo',
//   async (data: any, thunkApi) => {
//     const response: any = await axios
//       .post(`${API_URL}admin/assignedUserbySuperAdmin`, data, {
//         headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
//       })
//       .catch((err) => {
//         toast.error(err?.response?.data?.error?.email)
//       })
//     thunkApi.dispatch(getAllAssigneeUser({userId: data?.userId}))
//     thunkApi.dispatch(stopLoading())
//     return response.data
//   }
// )

// export const deallocateUser: any = createAsyncThunk(
//   '/deallocateStaff',
//   async (data: any, thunkApi) => {
//     const response: any = await axios
//       .post(`${API_URL}admin/unassignedUserbySuperAdmin`, data, {
//         headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
//       })
//       .catch((err) => {
//         toast.error(err?.response?.data?.error?.email)
//       })
//     thunkApi.dispatch(getAllAssigneeUser({userId: data?.staffId}))
//     thunkApi.dispatch(stopLoading())
//     return response.data
//   }
// )

export const UpdateWhiteLabelStatus: any = createAsyncThunk(
  '/UpdateWhiteLabelStatus',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })
    thunkApi.dispatch(GetAllWhiteLabel())
    thunkApi.dispatch(WhiteLabelProfileData(data?.id))

    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }

    return response.data
  }
)

export const UpdateStatusForOwner: any = createAsyncThunk(
  '/updateStatusForOwner',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.post(`${API_URL}admin/updateStatus`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    return response.data
  }
)

const WhiteLAbelUser = createSlice({
  name: 'WhiteLAbelUser',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin///////////////////////////////////////////////////////////////////
    [GetAllUSerOfWhiteLabel.fulfilled]: (state, {payload}) => {
      return {...state, WhiteLabelUserList: payload.data}
    },
  },
})

export const getAllUSerOfWhiteLabel = (state: any) => state?.WhiteLabelUser?.WhiteLabelUserList

export default WhiteLAbelUser.reducer
